<template>
    <div :class="['case-list', sMove === 'top' ? 'show-all':'', sMove === 'bottom' ? 'show-half':'',isEmpty? 'show-empty':'']">
        <div class="title-container " @click="sMove === 'top' ? goBottom() : goTop()">
            <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/business/project-model/position-address-icon.png" class="title-position-icon" alt="">
            <p class="address-context">{{ sCity }}</p>
            <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/business/project-model/turn-down-icon.png" v-if="sMove === 'bottom' || !sMove" alt="" class="top turn-icon">
            <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/business/project-model/turn-down-icon.png" v-if="sMove === 'top'" alt="" class="bottom turn-icon">
        </div>


        <pull-to
            :is-top-bounce="false"
            @infinite-scroll="upRefresh"
            :top-config="TOP_DEFAULT_CONFIG"
            :is-bottom-bounce="false"
            bottom-block-height:0
            top-block-height:0
        >
            <ul class="list" v-if="arrCaseList.length !== 0">
                <li v-for="(item, index) in arrCaseList" :key="item.id" @click.stop="toCaseDetail(item.id, item.is_new)">
                    <img class="project-img" v-lazy="cover(item)" alt=""/>
                    <div class="list-right">
                        <p class="title">{{ item.city_name }}-{{ item.address }}{{ item.house_area ? item.house_area + 'm²' : '' }}户型安装案例</p>
                        <!-- <p class="info">{{item.house_style}},{{item.house_area}}m²</p> -->
                        <div class="shop-list">
                            <span class="shop" v-for="(item, index) in  textFormat(item.scence)" :key="index">{{ item.type_name }}</span>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="no-data" v-else>暂无更多案例</div>
        </pull-to>
    </div>
</template>

<script>
// import path from "@/path";
import PullTo from "vue-pull-to";

export default {
    name: 'caseMap',
    components: {
        PullTo,
    },
    data() {
        return {
            TOP_DEFAULT_CONFIG: {
                pullText: "下拉刷新", // 下拉时显示的文字
                triggerText: "释放更新", // 下拉到触发距离时显示的文字
                loadingText: "加载中...", // 加载中的文字
                doneText: "加载完成", // 加载完成的文字
                failText: "加载失败", // 加载失败的文字
                loadedStayTime: 400, // 加载完后停留的时间ms
                stayDistance: 50, // 触发刷新后停留的距离
                triggerDistance: 70, // 下拉刷新触发的距离
            },

            sMove: ''
        }
    },
    props: {
        arrCaseList: {
            type: Array,
            default: []
        },
        // 城市
        sCity: String,
        sProvince:String,
        nLatitude:Number,
        nLongitude:Number,
        isEmpty:Boolean,
    },
    filters: {},
    created() {

    },
    mounted() {

    },
    computed: {},
    watch: {},
    methods: {
        cover(item) {
            // console.log(item)
            if (item.cover && item.is_new == 1) {
                return item.cover
            } else {
                return item.scence.length && item.scence[0].house_img.length ? item.scence[0].house_img[0].img_url : ''
            }

        },
        textFormat(value) {
            if (value.length !== 0) {
                let arr = []
                value.forEach(item => {
                    item.device_info.forEach(itemChild => {
                        arr.push(itemChild)
                    })
                })
                return arr
            } else {
                return []
            }
        },
        //下拉
        // downRefresh(loaded) {
        //     // this.page = 0;
        //     // this.bhow = false;
        //     // this.caseList = [];
        //     // this.getCaselist();
        //     // loaded("done");
        // },

        //上拉
        upRefresh(loaded) {
            // let page = this.page + 1;
            // this.page = page;
            // this.getCaselist(page);
            // this.loading = true;
            // console.log("2");
            // loaded("done");
            // console.log(123456)
        },

        closeCaseList() {
            this.$emit('close-case-list')
        },

        toCaseDetail(id, isNew) {
            this.$common.redirect('/case/map/v2/details',{
                city: this.sCity,
                province: this.sProvince,
                latitude: this.nLatitude,
                longitude: this.nLongitude,
                topicid: id
            })
        },

        goTop() {
            this.sMove = 'top'
        },
        goBottom() {

            this.sMove = 'bottom';
            this.$emit('hidenList')
        }
    }


}
</script>

<style lang="scss" scoped>
// @import './index.scss'
.case-list {
    width: 702px;
    height: 580px;
    position: fixed;
    bottom: 0;
    left: 24px;
    z-index: 999;
    background-color: #fff;
    overflow: hidden;
    border-radius: 24px 24px 0 0;
    padding: 24px 28px;

    .close {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 60px;
            height: 13px;
        }

        .top {
            transform: rotate(180deg);
        }
    }


    .title-container {
        display: flex;
        align-items: center;
        color: #6D6D6D;
        font-size: $baseSize;


        .title-position-icon {
            width: 32px;
            height: 32px;
            margin-right: 4px;
        }

        .turn-icon {

            width: 36px;
            height: 36px;
            margin-left: auto;
        }

        .top {
            transform: rotate(180deg);
        }

    }

    .list {


        li {
            padding: 32px 0;
            display: flex;
            border-bottom: 1px solid #F4F4F4;

            .project-img {
                width: 160px;
                height: 160px;
                object-fit: cover;
                flex: 0 0 auto;
                margin-right: 20px;
                border-radius: $littleRadius;
                overflow: hidden;
            }

            .list-right {
                flex: 1 1 auto;
                min-width: 0;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .title {
                    font-size: $bigSize;
                    color: $deepGreen;
                }


                .shop-list {
                    overflow-x: auto;
                    white-space: nowrap;
                    .shop {
                        font-size: $baseSize;
                        color: #858585;
                        display: inline-block;
                        margin-right: 10px;

                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
            }
        }

        li:last-child {
            margin-bottom: 50px;
            border-bottom: 0;
        }
    }
}

.show-all {
    animation: moveTop .3s linear forwards;
}

.show-half {
    animation: moveBottom .3s linear forwards;

    .vue-pull-to-wrapper {
        .scroll-container {
            overflow-y: hidden !important;
        }
    }

}
.show-empty{
     animation: moveEmpty .3s linear forwards;
}

.no-data {
    text-align: center;
    margin-top: 30px;
}
@keyframes moveEmpty {
    0% {
        height: 540px;
    }

    100% {
        height: 90px;
    }
}

@keyframes moveTop {
    0% {
        height: 540px;
    }

    100% {
        height: 70%;
    }
}

@keyframes moveBottom {
    0% {
        height: 70%;
    }

    100% {
        height: 90px;
    }
}
</style>

<style lang="scss">
.show-half {
    .vue-pull-to-wrapper {
        .scroll-container {
            overflow-y: hidden !important;
        }
    }
}
</style>